import React, { useState, useEffect } from 'react';
import { Button, Form, Container, Row, Col, Spinner } from 'react-bootstrap';
import clientAxios from '../../clients/clientAxios';
import { notify } from 'react-notify-toast';
import LoadingScreen from '../../Layout/LoadingScreen';

export default function SellTargetsConfig() {
  const currencyFormatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
  });

  const [targetValue, setTargetValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    let val = e.target.value.replace(/[^\d]/g, '');
    val = val.replace(/^0+(?!$)/, '');
    setTargetValue(val);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await clientAxios.put('/metric-targets', {
        kind: 'customer-care-sales',
        value: Number(targetValue || 0)
      });
      notify.show('Objetivo guardado correctamente.', 'success', 3000);
    } catch (err) {
      notify.show('Error al guardar el objetivo.', 'error', 3000);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const fetchTarget = async () => {
      try {
        const res = await clientAxios.get('/metric-targets', {
          params: { kind: 'customer-care-sales' }
        });
        setTargetValue(String(res.data.value));
      } catch (err) {
        setTargetValue('0');
        if (err.response?.status !== 404) {
          notify.show('Error al cargar el objetivo.', 'error', 3000);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchTarget();
  }, []);

  const displayValue = isFocused
    ? targetValue
    : currencyFormatter.format(Number(targetValue || 0));

  if (loading) {
    return <LoadingScreen/>;
  }

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
      <Row className="w-100 justify-content-center">
        <Col xs={12} md={6} lg={4}>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="sellTargetInput">
              <h2 className="w-100 text-center mb-4">Objetivo de Ventas</h2>
              <Form.Control
                type="text"
                inputMode="numeric"
                min={0}
                value={displayValue}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                placeholder="$0.00"
                className="text-center"
                style={{ marginTop: '32px' }}
                required
              />
            </Form.Group>
            <div className="d-flex justify-content-center mt-4">
              <Button variant="primary" type="submit" disabled={saving}>
                {saving ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Guardando...
                  </>
                ) : (
                  'Guardar'
                )}
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}
